module.exports = __webpack_public_path__ + "static/media/Image.56aad0d5.png";